import dynamic from 'next/dynamic';

const BuyOutGrid = dynamic(() => import('./BuyOutGrid/BuyOutGrid'));
const AddBuyOutModal = dynamic(() => import('./AddBuyOutModal/AddBuyOutModal'));

const BuyOutVehicleHeader = dynamic(() =>
  import('./BuyOutVehicleHeader/BuyOutVehicleHeader')
);
const GridCellApprovalStatus = dynamic(() =>
  import('./GridCellApprovalStatus/GridCellApprovalStatus')
);
const ChangeBuyOutStage = dynamic(() =>
  import('./ChangeBuyOutStage/ChangeBuyOutStage')
);
const BuyOutFilters = dynamic(() => import('./BuyOutFilters/BuyOutFilters'));
const ConfirmCancelModal = dynamic(() =>
  import('./ConfirmCancelModal/ConfirmCancelModal')
);
const ClientRejectedModal = dynamic(() =>
  import('./ClientRejectedModal/ClientRejectedModal')
);

const ConfirmSendToBacklog = dynamic(() =>
  import('./ConfirmSendToBacklog/ConfirmSendToBacklog')
);

const BuyoutTicketSidebar = dynamic(() =>
  import('./BuyoutTicketSidebar/BuyoutTicketSidebar')
);

export {
  BuyOutGrid,
  AddBuyOutModal,
  BuyOutVehicleHeader,
  GridCellApprovalStatus,
  ChangeBuyOutStage,
  BuyOutFilters,
  ConfirmCancelModal,
  ConfirmSendToBacklog,
  ClientRejectedModal,
  BuyoutTicketSidebar,
};
